import React from "react";
import "./NewsTicker.css";

const NewsTicker = () => {
  const message =
    "Dear Merchant/Customer, The Payment Gateway system will not be available on April 14th from 15:00 Hrs (afternoon) to April 15th 16:00 Hrs (afternoon) due to maintenance activities. Sorry for the inconvenience.";

  return (
    <div className="ticker-container">
      <div className="ticker-label">
        🔔 Announcement
      </div>

      <div className="ticker">
        <div className="ticker-track">
          <span>{message}</span>
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;